import { Button, Input, Space, Spin } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { SearchOutlined } from '@mui/icons-material';
import TableFetchData from '../../components/data-table/TableFetchData';
import { useTranslation } from 'react-i18next';
import { formatDateTime } from '../../utils/dateFormatUtils';
import DateRangeComponent from '../../components/date/DateRangeComponent';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import HeaderComponent from '../../components/header/headerComponent';
import { COUPON_USED_URL } from '../../api/URLs';
import { getDataRequest } from '../../api/serviceMethods';
import AirlyPaySvg from '../../assets/images/AirlyPay';
import WeChatSvg from '../../assets/images/WeChat';
function CouponDetailPage() {
    const [loading, setLoading] = useState(false);
    const [couponData, setCouponData] = useState([]);
    const [keyword, setkeyword] = useState('');
    const [dates, setDates] = useState([null, null]);
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
            total: 0,
        },
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const type = searchParams.get('type') || 'used'; // 'used' or 'unused'
    const tableColumns = [
        {
            title: <label className="titleCard14400">{t('Coupon Code')}</label>,
            render: (_, record) => (
                <label className="text-capitalize">
                    {record && record?.couponCode || ""}
                </label>
            ),
        },
        {
            title: <label className="titleCard14400">{t('User ID')}</label>,
            render: (_, record) => (
                <label className="text-capitalize">
                   {record && record?.memberId || ""}
                </label>
            ),
        },
        {
            title: <label className="titleCard14400">{t('Payment Amount')}</label>,
            render: (_, record) => (
                <label className="text-capitalize">
                   {record?.paidAmount ? `¥${record.paidAmount}` : ""}
                </label>
            ),
        },
        {
            title: <label className="titleCard14400">{t('Order Number')}</label>,
            render: (_, record) => (
                <label className="text-capitalize">
                   {record && record?.orderId || ""}
                </label>
            ),
        },
        {
            title: <label className="titleCard14400">{t('Used Time')}</label>,
            dataIndex: 'usedTS',
            sorter: true,
            key: 'usedTS',
            render: (_, record) => (
                <label className="text-capitalize">
                   {record?.usedTS ? formatDateTime(record.usedTS) : ""}
                </label>
            ),
        },
        {
            title: <label className="titleCard14400">{t('Payment Portal')}</label>,
            dataIndex: 'paymentGateway',
            key: 'paymentGateway',
            render: (text) => {
                if (!text || text === '-') return "";
                if (text === 'alipay') {
                    return <AirlyPaySvg />;
                } else if (text === 'wechatpay' || text === 'wechat') {
                    return <WeChatSvg />;
                }
                return text;
            }
        }
    ];
    const initLoadData = async (searchValue) => {
        setLoading(true);
        try {
            const params = {
                keyword: searchValue?.trim() || '',
                startDate: dates[0] || '',
                endDate: dates[1] || '',
                status: type === 'used' ? 'used' : 'unused',
                sortKeys: { [tableParams.sortField]: tableParams.sortOrder === "ascend" ? "asc" : "desc" },//descend
                pageNo: tableParams.pagination.current,
                pageSize: tableParams.pagination.pageSize
            };

            const res = await getDataRequest(`${COUPON_USED_URL}/${id}`, params);
            if (res && res.status === 200) {
                const data = res.data || [];
                setCouponData(data);
                setTableParams({
                    ...tableParams,
                    pagination: {
                        ...tableParams.pagination,
                        total: res.total || data.length,
                    },
                });
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        initLoadData(keyword);
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        tableParams?.sortOrder,
        tableParams?.sortField,
        JSON.stringify(tableParams.filters),
    ], [tableParams.pagination?.current, tableParams.pagination?.pageSize, id, type]);
    
    return (
        <HeaderComponent pageTitle={
            <span style={{cursor: "pointer"}} onClick={() => navigate(-1)}>
                <ArrowLeftOutlined /> {t('Coupon Management')} / {type === 'used' ? t('Used Coupons') : t('Unused Coupons')}
            </span>
        }>
            <div className="container- box-shadow h-100">
                <div className="w-100 h-100 overflow-auto" style={{ padding: "20px 25px" }}>
                    <Spin spinning={loading}>
                        <div className="w-100">
                            <div className="d-flex justify-content-between mt-3 mb-3">
                                <div className="d-flex align-items-center col-8 row">
                                    <div className='col-4'>
                                        <Input
                                            placeholder={t('Search')}
                                            size="large"
                                            disabled={loading}
                                            allowClear
                                            prefix={<SearchOutlined style={{ color: '#8c8c8c', cursor: "pointer", opacity: "0.4" }} />}
                                            onChange={(e) => setkeyword(e.target.value)}
                                        />
                                    </div>
                                    <div className='col-4'>
                                        <DateRangeComponent value={dates} setValue={setDates} />
                                    </div>
                                </div>
                                <div className='d-flex alight-items-center'>
                                    <Button size={'large'} onClick={() => initLoadData(keyword)}>{t('btnSearch')}</Button>
                                </div>
                            </div>
                        </div>
                        <div className="w-100">
                            <TableFetchData
                                tableParams={tableParams} setTableParams={setTableParams}
                                data={couponData}
                                columns={tableColumns}
                                appendable={false}
                                removable={false}
                                numbered={false}
                            />
                        </div>
                    </Spin>
                </div>
            </div>
        </HeaderComponent>
    );
}
export default CouponDetailPage;